import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

// API
export interface ForumArchivedCampaignsFetchAction extends Action {}

export interface ForumArchivedCampaignsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { campaigns: number[] };
}

export const FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST = "FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST";
export interface ForumArchivedCampaignsFetchRequestAction
    extends ForumArchivedCampaignsFetchAction, APIRequestAction {
    readonly type: typeof FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST;
}

export const FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS = "FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS";
export interface ForumArchivedCampaignsFetchSuccessAction
    extends
        ForumArchivedCampaignsFetchAction,
        APISuccessAction<ForumArchivedCampaignsFetchNormalizedResponse> {
    readonly type: typeof FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS;
}

export const FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE = "FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE";
export interface ForumArchivedCampaignsFetchFailureAction
    extends ForumArchivedCampaignsFetchAction, APIFailureAction {
    readonly type: typeof FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE;
}

export const forumArchivedCampaignsFetch = {
    request: (): ForumArchivedCampaignsFetchRequestAction => ({
        type: FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST,
    }),
    success: (
        response: ForumArchivedCampaignsFetchNormalizedResponse,
    ): ForumArchivedCampaignsFetchSuccessAction => ({
        type: FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS,
        response,
    }),
    failure: (error: any): ForumArchivedCampaignsFetchFailureAction => ({
        type: FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE,
        error,
    }),
};

// Triggers
export const FORUM_ARCHIVE_CAMPAIGNS_LOAD = "FORUM_ARCHIVE_CAMPAIGNS_LOAD";

export interface ForumArchivedCampaignsLoadAction extends ForumArchivedCampaignsFetchAction {
    readonly type: typeof FORUM_ARCHIVE_CAMPAIGNS_LOAD;
}

export const forumArchivedCampaignsLoad = (): ForumArchivedCampaignsLoadAction => ({
    type: FORUM_ARCHIVE_CAMPAIGNS_LOAD,
});
